import './select.less';
import React from 'react';
import PropTypes from 'prop-types';
import Suggest from './suggest';

const propTypes = {
	langs: PropTypes.array,
	defaultLang: PropTypes.string,
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
	value: PropTypes.any // redux-form input.value
};

const defaultProps = {
	disabled: false
};

class LangSelect extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			langs: this.getLangs(props)
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			langs: this.getLangs(nextProps)
		});
	}

	onOpen() {
		if (!this.props.disabled) {
			this.setState({
				isOpen: true
			});
		}
	}

	onToggleSelectLanguage(id) {
		const { isSingle } = this.props;

		let langs = this.state.langs.map((lang, ind, arr) => {
			if (lang.id === id) {
				lang.isSelected = !lang.isSelected;
			} else if (isSingle) {
				lang.isSelected = false;
			}
			return lang;
		});

		this.setState(
			prev => ({ langs }),
			() => this.props.onChange && this.props.onChange(
				langs.filter(lang => lang.isSelected).map(lang => lang.id)
			)
		);
	}

	handleClickOutside() {
		this.setState({
			isOpen: false
		});
	}

	getLangs(props) {
		const { langs, value } = props;
		return langs.map(lang => ({
			...lang,
			isSelected: value.indexOf(lang.id) > -1
		}));
	}

	render() {
		const selected = this.state.langs.filter(lang => lang.isSelected);
		return (
			<div className="lang-select">
				<div className="lang-select__head" onClick={this.onOpen.bind(this)}>
					{ selected.length === 1 && (
						<span className="label single">{selected[0].id}</span>
					)}

					{ selected.length > 1 && (
						<span className="label multi">{selected.length}</span>
					)}

				</div>
				{ this.state.isOpen && (
					<Suggest
						langs={this.state.langs}
						onToggleLanguage={this.onToggleSelectLanguage.bind(this)}
						onClickOutside={this.handleClickOutside.bind(this)} />
				)}
			</div>
		);
	}
}

LangSelect.propTypes = propTypes;
LangSelect.defaultProps = defaultProps;

export default LangSelect;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/lang/select.js